/**
 * Utility function to combine CSS classes with conditional logic
 */
export function cn(...classes: (string | undefined | null | boolean)[]): string {
    return classes.filter(Boolean).join(' ');
}

/**
 * Utility function to generate consistent spacing classes
 */
export function getSpacing(size: 'xs' | 'sm' | 'md' | 'lg' | 'xl'): string {
    const spacingMap = {
        xs: 'px-2 py-1',
        sm: 'px-3 py-1.5',
        md: 'px-4 py-2',
        lg: 'px-6 py-3',
        xl: 'px-8 py-4'
    };
    return spacingMap[size];
}

/**
 * Utility function to generate text size classes
 */
export function getTextSize(size: 'xs' | 'sm' | 'md' | 'lg' | 'xl'): string {
    const sizeMap = {
        xs: 'text-xs',
        sm: 'text-sm',
        md: 'text-base',
        lg: 'text-lg',
        xl: 'text-xl'
    };
    return sizeMap[size];
}

/**
 * Utility function to generate border radius classes
 */
export function getRounded(size: 'none' | 'sm' | 'md' | 'lg' | 'full'): string {
    const roundedMap = {
        none: '',
        sm: 'rounded-sm',
        md: 'rounded-md',
        lg: 'rounded-lg',
        full: 'rounded-full'
    };
    return roundedMap[size];
}